import { ToastOptions } from 'react-toastify';

/** Accent ribbon metrics shared with sidenav active-item chrome. */
export const RIBBON_TOAST_ACCENT = {
  width: 3,
  insetX: 4,
  insetY: 6,
  radius: 2,
} as const;

/** Transparent shell so MUI Paper owns the visible surface (theme paper + elevation). */
export const RIBBON_TOAST_STYLE: ToastOptions['style'] = {
  padding: 0,
  background: 'transparent',
  boxShadow: 'none',
  color: 'inherit',
  minHeight: 'auto',
};

/** Auto-close duration for non-sticky ribbon toasts (matches in-card progress bar). */
export const RIBBON_TOAST_AUTO_CLOSE_MS = 4000;
